import React from 'react'
import { size as _size } from 'lodash'

import { ListSubBtn } from './ListSubBtn'

import { CSSHandler } from 'utils'


const ListBtn = ({
	btnID,
	item,
	itemDidTapped,
	itemWillShow,
	searchValue,
	isSmallScreen,
	itemType,
	onClick
}) => {
	const { account, explanation, sub_account, title_shown } = item;
	// const isQADefault = itemDidTapped.isDefault;

	if (sub_account.length === 0) { return null; }

	let isParentActive = true;

	if (itemWillShow) {
		isParentActive = account === itemWillShow.account
				&& _size(sub_account.find((subItem) => (
					subItem.label === itemWillShow.sub_account)
				)) > 0;
	}

	if (itemDidTapped) {
		isParentActive = account === itemDidTapped.account && _size(sub_account.find(
			(subItem) => (subItem.label === itemDidTapped.sub_account)
		)) > 0;
	}

	isParentActive = (isParentActive && !isSmallScreen) ? 'active' : '';
		
	const firstSub = sub_account[0].label;
	
	return (
		<div className={`content-group ${isParentActive}`}>
			<div
				className='content-title'
				data-account={account}
				data-subaccount={firstSub}
				data-type={itemType}
				data-style='title'
				onClick={!isParentActive ? onClick : () => {}}
			>
				{title_shown
					? CSSHandler.highlightKeywords(title_shown, searchValue)
					: (
						<>
							{CSSHandler.highlightKeywords(account, searchValue)}

							{explanation ? ' - ' : null}

							{explanation ? CSSHandler.highlightKeywords(explanation, searchValue)
									: null}
						</>
					)
				}
			</div>

			{sub_account.map((subItem, idx) => (
				<ListSubBtn
					btnID={btnID ? `${btnID}-${idx}` : ''}
					subItem={subItem}
					account={account}
					itemDidTapped={itemDidTapped}
					itemWillShow={itemWillShow}
					searchValue={searchValue}
					isSmallScreen={isSmallScreen}
					itemType={itemType}
					onClick={onClick}
					key={idx}
				/>
			))}
		</div>
	);
};


export { ListBtn }
